module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1900.743f42c0.svg";